var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99708 11.1999C7.53042 11.1999 7.06375 11.0199 6.71042 10.6666L2.36375 6.31993C2.17042 6.12659 2.17042 5.8066 2.36375 5.61326C2.55708 5.41993 2.87708 5.41993 3.07042 5.61326L7.41708 9.95993C7.73708 10.2799 8.25708 10.2799 8.57708 9.95993L12.9237 5.61326C13.1171 5.41993 13.4371 5.41993 13.6304 5.61326C13.8238 5.8066 13.8238 6.12659 13.6304 6.31993L9.28375 10.6666C8.93042 11.0199 8.46375 11.1999 7.99708 11.1999Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.e30fa951e7b9ee5b7b5d29ee2a20c789.svg";
export { ForwardRef as ReactComponent };